<template>
  <div class="adminpanel">

      <b-row>
        <b-col>
            <global-settings></global-settings>
        </b-col>
      </b-row>

      <!-- SPACER-->
      <spacer-card></spacer-card>
      <!-- SPACER-->

      <b-row>
        <b-col>
            <project-settings></project-settings>
        </b-col>
      </b-row>


  </div>
</template>

<script>
import Globalsettings from '@/components/admin/GlobalSettings.vue';
import Projectsettings from '@/components/admin/ProjectSettings.vue';
import Spacer from '@/components/card/Spacer';

export default {
    data () {
        return {

        }
    },
        components: {
      'global-settings': Globalsettings,
      'project-settings': Projectsettings,
      'spacer-card': Spacer
    }
}
</script>
